import {DateCalendar} from '@mui/x-date-pickers';
import {Moment} from 'moment';
import {maxDateTimeAllow} from '../shared/date-max-time';

type PlannerSideCalendarProps = {
  value: Moment;
  onChange: (newValue: Moment) => void;
};

export function PlannerSideCalendar(props: PlannerSideCalendarProps) {
  const DAY_SIZE = 28;
  return (
    <DateCalendar
      maxDate={maxDateTimeAllow()}
      reduceAnimations={true}
      views={['day']}
      sx={{
        '&.MuiDateCalendar-root': {
          width: 200,
          height: 'initial',
        },
        '& .MuiPickersSlideTransition-root': {
          minHeight: 'initial',
        },
        '& .MuiTypography-caption': {
          width: DAY_SIZE,
          margin: 0,
          fontSize: 16,
        },
        '& .MuiPickersCalendarHeader-root': {
          padding: '0 6px',
          margin: '0',
          textTransform: 'capitalize',
        },
        '& .MuiPickersArrowSwitcher-root': {
          height: DAY_SIZE,
        },
        '& .MuiPickersArrowSwitcher-root > button': {
          width: DAY_SIZE,
        },
        '& .MuiPickersArrowSwitcher-root > .MuiPickersArrowSwitcher-spacer': {
          width: DAY_SIZE,
        },
        '& .MuiPickersDay-dayWithMargin': {
          margin: 0,
        },
        '& .MuiPickersDay-root': {
          width: DAY_SIZE,
          height: DAY_SIZE,
          fontSize: 14,
        },
      }}
      value={props.value}
      onChange={props.onChange}
    />
  );
}
